/**
 * Line drawings of the three frames the store sells. Drawn, not icons: the
 * page is about eyewear, so the product should look like eyewear.
 */
const SHAPES = {
  round: (
    <>
      <circle cx="37" cy="27" r="17" />
      <circle cx="83" cy="27" r="17" />
      <path d="M54 24c4-4 8-4 12 0" fill="none" />
      <path d="M20 22 5 17M100 22l15-5" fill="none" />
    </>
  ),
  aviator: (
    <>
      <path d="M21 14h30c3 0 5 3 5 8 0 12-8 20-19 20S17 33 17 21c0-4 1-7 4-7Z" />
      <path d="M99 14H69c-3 0-5 3-5 8 0 12 8 20 19 20s20-9 20-21c0-4-1-7-4-7Z" />
      <path d="M55 17h10M56 24c3-3 5-3 8 0" fill="none" />
      <path d="M18 17 5 14M102 17l13-3" fill="none" />
    </>
  ),
  square: (
    <>
      <rect x="15" y="12" width="40" height="28" rx="7" />
      <rect x="65" y="12" width="40" height="28" rx="7" />
      <path d="M55 22c3-3 7-3 10 0" fill="none" />
      <path d="M15 19 4 16M105 19l11-3" fill="none" />
    </>
  ),
};

export default function FrameArt({ shape = 'round', className = '' }) {
  return (
    <svg
      viewBox="0 0 120 54"
      className={className}
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="currentColor"
      fillOpacity="0.08"
      aria-hidden
    >
      {SHAPES[shape]}
    </svg>
  );
}
